import React, {useEffect, useState} from "react";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import {useTranslation} from "react-i18next";
import moment from "moment/moment";
import TableFooter from "../../../components/table-footer/TableFooter";
import NoData from "../../../components/no-data";

const AffiliateRefferedUsers = (props) => {
    const [loading, setLoading] = useState(true)
    const [total, setTotal] = useState(0)
    const [data, setData] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)

    const {t} = useTranslation()

    useEffect(() => {
        getCampaigns()
    }, [page, limit])

    const getCampaigns = () => {
        setLoading(true)
        associateServices.getReferredUsers({
            limit,
            page,
        }).then(res => {
            setData(res?.data?.data)
            setTotal(res?.data?.total)
            setLoading(false)
        })
    }
    const handlePrev = () => setPage(prevState => prevState <= 1 ? 1 : prevState - 1)
    const handleNext = () => setPage(prevState => prevState + 1)

    return (
        <div className="tab-pane fade show active">


            <div className="tab-content">
                {
                    loading ? <Loading/> :
                        <div className="tab-pane fade show active">
                            <div className="table-responsive">
                                {
                                    data?.length <= 0 ? <NoData desc={t('transactions.bets.empty')}/> :
                                        <table className="xtable xtable--small">
                                            <thead>
                                            <tr>
                                                <th>{t('affiliate.referred-user.table.user')}</th>
                                                <th>{t('affiliate.referred-user.table.campaign')}</th>
                                                <th>{t('affiliate.referred-user.table.code')}</th>
                                                <th>{t('affiliate.referred-user.table.time')}</th>
                                                <th>{t('affiliate.referred-user.table.count')}</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            {
                                                data?.map(debit => (
                                                    <tr key={debit?.id}>
                                                        <td className="cursor-pointer">
                                                            <div
                                                                className="xtable__text xtable__text--text-secondary">
                                                                {debit?.customer?.username}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="xtable__text xtable__text--green">
                                                                {debit?.campaign?.name}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="xtable__text">
                                                                {debit?.campaign?.secret}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="xtable__text">

                                                    <span className="xtable__text-date">
                                                                        {moment.unix(debit?.timestamp || 0).format('MMMM Do')}

                                                        <small>
                                                                        {moment.unix(debit?.timestamp || 0).format('h:mm:ss a')}
                                                                    </small>
                                                                    </span>

                                                            </div>
                                                        </td>


                                                        <td>
                                                            <div className="xtable__text">
                                                                {debit?.usages_count || '0.00'}
                                                            </div>
                                                        </td>


                                                    </tr>
                                                ))
                                            }

                                            </tbody>
                                        </table>

                                }
                            </div>
                            <TableFooter
                                total={total}
                                limit={limit}
                                handlePrev={handlePrev}
                                handleNext={handleNext}
                                section={'debit'}
                                page={page}
                                buttonText={null}
                            />
                        </div>
                }
            </div>


        </div>
    )
}

export default AffiliateRefferedUsers
